import { Controller } from '@hotwired/stimulus'

// Breadcrumbs compactados en móvil (Ds::BreadcrumbsComponent): el «...» despliega
// las migas plegadas. El botón desaparece al pulsarlo, así que con teclado el foco
// pasa a la primera miga que aparece para no perderse. Con el dedo no: la dejaría
// pintada en el color de hover como si estuviera seleccionada.
export default class extends Controller {
  desplegar (event) {
    this.element.classList.add('rnk-DsBreadcrumbs-desplegado')
    // `detail` es 0 cuando el click lo genera el teclado (Enter o espacio).
    if (event.detail === 0) this.element.querySelector('.rnk-DsBreadcrumbs_Miga-plegada a')?.focus()
  }
}
